import { render, staticRenderFns } from "./IncomeSourceReport.vue?vue&type=template&id=6987f940"
import script from "./IncomeSourceReport.vue?vue&type=script&lang=js"
export * from "./IncomeSourceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports